import React, { useEffect, useState, useCallback } from 'react';
import { Button, Card, Form, Input, InputNumber, message, Popconfirm, Select, Space, Spin, Table, Modal } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { getFormattedDouble } from '../../utils/format';
import { tyraRequests } from '../../requests';
import TyraFormFields from '../tyraFormFields/TyraFormFields';
import './Tyra.scss';

const { Option } = Select;

const Tyra = ({ month, year, total, setTotal }) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editForm] = Form.useForm();

  const fetchData = async (newMonth, newYear) => {
    const response = await tyraRequests.getAllByMonthAndYear(newMonth, newYear);
    setData(response.data);
    setTotal(response.data.reduce((t,a) => (t + a.value), 0));
  };

  useEffect(() => {
    fetchData(month, year);
  }, [month, year]);

  const handleCreate = async () => {
    form
      .validateFields()
      .then(async (values) => {
      console.log(values);
        const params = {
          ...values,
          value: values.value.replace(',', '.'),
          month,
          year,
        };
        await tyraRequests.create(params);
        form.resetFields();
        fetchData(month, year);
      })
      .catch((errorInfo) => {
        console.log('Erro na validação:', errorInfo);
      });
  };

  const handleDelete = async (id) => {
    await tyraRequests.delete(id);
    fetchData(month, year);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    editForm.setFieldsValue({
      ...record,
      value: record.value.toString().replace('.', ','),
    });
    setIsModalVisible(true);
  };

  const handleEditSubmit = async () => {
    try {
      const values = await editForm.validateFields();
      const params = {
        ...values,
        value: values.value.replace(',', '.'),
        month,
        year,
      };
      // Supondo que sua API possua um endpoint PUT para atualizar
      await tyraRequests.update(params, editingRecord.id);
      setIsModalVisible(false);
      setEditingRecord(null);
      fetchData(month, year);
    } catch (error) {
      console.log('Erro ao validar/atualizar:', error);
    }
  };

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Subcategoria',
      dataIndex: 'subcategory',
      key: 'subcategory',
      render: (text) => {
        switch (text) {
          case 'TYRA_MARKET':
            return 'Tyra + Market'
          case 'TYRA':
            return 'Tyra'
          default:
            return text;
        }
      },
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      sorter: (a, b) => a.value - b.value,
      render: (text) => `R$ ${getFormattedDouble(text)}`,
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (record) => (
        <Space>
          <EditOutlined onClick={() => handleEdit(record)} style={{ cursor: 'pointer' }} />
          <Popconfirm
            title="Tem certeza que deseja excluir este registro?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sim"
            cancelText="Não"
          >
            <DeleteOutlined style={{ cursor: 'pointer' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="Tyra">
      <Spin tip="Carregando" spinning={loading}>
        <Card title="Cadastrar novo" style={{ margin: '20px 0' }}>
          <Form form={form} autoComplete="off" layout="vertical" className="form-container">
            <TyraFormFields />
            <Form.Item style={{ display: 'flex', flexDirection: 'column-reverse' }}>
              <Button type="primary" onClick={handleCreate}>
                Adicionar
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Table columns={columns} dataSource={data} pagination={false} />

        <Modal
          title="Editar Envio"
          visible={isModalVisible}
          onOk={handleEditSubmit}
          onCancel={() => { setIsModalVisible(false); setEditingRecord(null); }}
          okText="Salvar"
          cancelText="Cancelar"
        >
          <Form form={editForm} layout="vertical" autoComplete="off">
            <TyraFormFields />
          </Form>
        </Modal>
      </Spin>
    </div>
  );
};

export default Tyra;
